export const FIELDS_GIFTCARD_BALANCE = [
  {
    name: 'giftCardNumber',
    inputAdornment: '',
    label: 'Nº de tu giftcard',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresa 7 o 20 dígitos',
  },
];
